var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41939",
    "data-name": "Group 41939",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3150",
    "data-name": "Ellipse 3150",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#14b7dd",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "conversation",
    transform: "translate(7.281 7.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41932",
    "data-name": "Group 41932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41931",
    "data-name": "Group 41931",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180968",
    "data-name": "Path 180968",
    d: "M15.383,16.007l-.9-2.61A6.528,6.528,0,0,0,8.733,4.012a6.521,6.521,0,0,0-6.626,6.435A4.752,4.752,0,0,0,.664,16.286l-.618,1.8a.849.849,0,0,0,.8,1.125.855.855,0,0,0,.278-.047l1.8-.618A4.772,4.772,0,0,0,4.954,19h.007A4.745,4.745,0,0,0,8.8,17.051a6.542,6.542,0,0,0,2.695-.66l2.61.9a1.016,1.016,0,0,0,.33.056,1.009,1.009,0,0,0,.95-1.337ZM4.961,18.083H4.955A3.843,3.843,0,0,1,3.17,17.64a.46.46,0,0,0-.364-.028l-1.843.633L1.6,16.4a.46.46,0,0,0-.028-.364A3.832,3.832,0,0,1,2.192,11.6,6.546,6.546,0,0,0,7.649,16.98,3.822,3.822,0,0,1,4.961,18.083ZM14.493,16.4a.083.083,0,0,1-.092.021l-2.794-.96a.459.459,0,0,0-.364.028,5.613,5.613,0,0,1-2.607.647H8.627a5.624,5.624,0,0,1-5.6-5.511A5.6,5.6,0,0,1,8.718,4.931a5.6,5.6,0,0,1,4.864,8.217.46.46,0,0,0-.028.364l.96,2.794A.083.083,0,0,1,14.493,16.4Z",
    transform: "translate(0 -4.011)",
    fill: "#76747f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41934",
    "data-name": "Group 41934",
    transform: "translate(5.431 4.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41933",
    "data-name": "Group 41933",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180969",
    "data-name": "Path 180969",
    d: "M186.028,139.512h-5.475a.459.459,0,0,0,0,.919h5.475a.459.459,0,1,0,0-.919Z",
    transform: "translate(-180.094 -139.512)",
    fill: "#76747f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41936",
    "data-name": "Group 41936",
    transform: "translate(5.431 5.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41935",
    "data-name": "Group 41935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180970",
    "data-name": "Path 180970",
    d: "M186.028,202.183h-5.475a.459.459,0,0,0,0,.919h5.475a.459.459,0,1,0,0-.919Z",
    transform: "translate(-180.094 -202.183)",
    fill: "#76747f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41938",
    "data-name": "Group 41938",
    transform: "translate(5.43 7.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41937",
    "data-name": "Group 41937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180971",
    "data-name": "Path 180971",
    d: "M183.92,264.852h-3.367a.459.459,0,1,0,0,.919h3.367a.459.459,0,0,0,0-.919Z",
    transform: "translate(-180.093 -264.852)",
    fill: "#76747f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.1a135c1b724dab43dab193ac08d70878.svg";
export { ForwardRef as ReactComponent };